export const PauseIcon = () => {
  return (
    <svg
      width="55"
      height="56"
      viewBox="0 0 55 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        position: "absolute",
        top: "0px",
        left: "0px",
        pointerEvents: "none",
      }}
    >
      <rect
        x="27.5"
        y="15.5"
        width="12"
        height="25"
        rx="4.5"
        fill="#E5CFAB"
        stroke="black"
        stroke-width="5"
      />
      <rect
        x="15.5"
        y="15.5"
        width="12"
        height="25"
        rx="4.5"
        fill="#E5CFAB"
        stroke="black"
        stroke-width="5"
      />
    </svg>
  );
};
